import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/Layout"
import * as styles from "../styles/home.module.scss"
import { BgImage } from "gbimage-bridge"
import { getImage } from "gatsby-plugin-image"
import HeaderHome from "../components/HeaderHome"

export default function Home({ data }) {

  const banner = getImage(data.banner)
  const eddie = getImage(data.eddie)

  return (
    <Layout pageTitle="Home">
      <HeaderHome imageData={banner} bgClass={styles.header_bg} />
      <section className={styles.home_verve_intro} id="main">
        <div className="container">
          <h1>We are Verve Kombucha</h1>
          <p>Verve Kombucha is a kombucha brewery located in the heart of downtown Waterloo, complete with a private event space. We embody what "verve" means:</p>
          <div className={styles.verve_definition}>
            <p><span className={styles.verve_noun}>vərv, <i>n.</i></span> <b>1.</b> passion, <b>2.</b> enthusiasm, <b>3.</b> life</p>
          </div>
          <p>We brew our own all-natural kombucha on site and distribute to our wholesale partners around the state.</p>
        </div>
      </section>
      <section className={styles.home_meet_brewer}>
        <div className={styles.brewer_bio}>
          <div className={styles.brewer_bio_content}>
            <h2>Meet Our Brewer</h2>
            <p>Eddie majored in biology... Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
          </div>
        </div>
        <div className={styles.brewer_img}>
          <BgImage
            Tag="div"
            image={eddie}
            className={styles.eddie_brewer}
            backgroundColor={`rgba(239,93,162,0.6)`}
          >
          </BgImage>
        </div>
      </section>
    </Layout>
  )
}

export const query = graphql`
  query {
    banner: file(relativePath: {eq: "bottled_verve_kombucha_wide.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH,
          placeholder: BLURRED
        )
      }
    }
    eddie: file(relativePath: { eq: "eddie_brewer.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
      }
    }
  }
`;